import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { api_url } from "../../config/config";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../Context/Createcontext";
import addToCartIcon from "../../Icons/addToCartIcon.svg";
import { toast } from "react-hot-toast";
import Popup from "../common/Popup";
import wish from "../../images/wish.svg";
import wishlist from "../../images/wishlist_nofill.svg";
import { useWishlist } from "../../Context/WishlistContext";

const FeaturedProduct_home = () => {
  const {
    handleAddToCart,
    showLoginPopup,
    setShowLoginPopup,
    handleRemoveFromCart,
    cartItems,
    setCartItems,
  } = useCart();

  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [productsPerPage, setProductsPerPage] = useState(2);
  const [currentPage, setCurrentPage] = useState(0);
  const [tooltipOpen, setTooltipOpen] = useState(null);

  const {
    wishlist: wishlistItems,
    addToWishlist,
    removeFromWishlist,
    loading: wishlistLoading,
  } = useWishlist();

  const intervalRef = useRef(null);
  const scrollRef = useRef(null);
  const navigate = useRef(useNavigate()).current;

  const updateProductsPerPage = () => {
    const w = window.innerWidth;
    if (w >= 1280) setProductsPerPage(5);
    else if (w >= 1024) setProductsPerPage(4);
    else if (w >= 768) setProductsPerPage(4);
    else setProductsPerPage(2);
  };

  useEffect(() => {
    updateProductsPerPage();
    window.addEventListener("resize", updateProductsPerPage);
    return () => window.removeEventListener("resize", updateProductsPerPage);
  }, []);

  useEffect(() => {
    const fetchFeaturedProduct = async () => {
      try {
        const response = await fetch(
          `${api_url}/featured/product?page=1&limit=100`,
          {
            headers: { "Content-Type": "application/json", "x-auth": "false" },
          },
        );
        if (!response.ok) throw new Error("Failed to fetch featured products");
        const data = await response.json();
        (data.data || []).forEach((product) => {
          const img = new Image();
          img.src = product?.product_images?.image_url?.primary_image;
        });
        setFeaturedProducts(data.data || []);
      } catch (error) {
        console.error("Error fetching featured products:", error);
      }
    };
    fetchFeaturedProduct();
  }, []);

  const displayedProducts = featuredProducts.slice(0, 10);

  const OutOfQuantityCheck = (variants) =>
    variants.every((v) => v.quantity === 0);

  const getCartQuantity = (variantId) => {
    const item = cartItems.find((ci) => ci.variant_id === variantId);
    return item ? item.quantity : 0;
  };

  const handleProductClick = (product_id, item) => {
    navigate(`/products/${item.name?.toLowerCase().replace(/\s+/g, "-")}`, {
      state: { product_id },
    });
  };

  const handleIncrease = async (event, variant, item) => {
    event.preventDefault();
    if (!variant?.variant_id) return;
    const quantity = getCartQuantity(variant.variant_id);
    const cartResponse = await fetch(`${api_url}/cart`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
      body: JSON.stringify({
        product_id: variant.product_id,
        quantity: quantity + 1,
        variant_id: variant.variant_id,
      }),
    });
    const responseData = await cartResponse.json();
    if (
      !cartResponse.ok ||
      responseData.message?.toLowerCase().includes("stock not available")
    ) {
      toast.error(`${item.name} is out of stock`);
      return;
    }
    setCartItems((prev) =>
      prev.map((ci) =>
        ci.variant_id === variant.variant_id
          ? { ...ci, quantity: ci.quantity + 1 }
          : ci,
      ),
    );
  };

  const handleDecrease = async (event, variant) => {
    event.preventDefault();
    if (!variant?.variant_id) return;
    const quantity = getCartQuantity(variant.variant_id);
    if (quantity === 1) {
      await handleRemoveFromCart(variant.product_id, variant.variant_id);
      setCartItems((prev) =>
        prev.filter((ci) => ci.variant_id !== variant.variant_id),
      );
      return;
    }
    const cartResponse = await fetch(`${api_url}/cart`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
      body: JSON.stringify({
        product_id: variant.product_id,
        quantity: quantity - 1,
        variant_id: variant.variant_id,
      }),
    });
    const responseData = await cartResponse.json();
    if (
      !cartResponse.ok ||
      responseData.message?.toLowerCase().includes("stock not available")
    ) {
      toast.error(`Something went wrong`);
      return;
    }
    setCartItems((prev) =>
      prev.map((ci) =>
        ci.variant_id === variant.variant_id
          ? { ...ci, quantity: ci.quantity - 1 }
          : ci,
      ),
    );
  };

  return (
     <section className="relative w-full py-8 sm:py-6 lg:py-6 font-poppins overflow-hidden bg-white">

      {/* Subtle bg blobs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-80 h-80 rounded-full bg-[#fff3ee] blur-3xl opacity-60" />
        <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-[#eaf4f3] blur-3xl opacity-60" />
      </div>

      <div className="relative px-4 sm:px-6 lg:px-6 xl:px-6">
        {/* ── Header ── */}
        <div className="flex items-center justify-between mb-7 sm:mb-9">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="w-5 h-[2px] bg-[#ff601e] rounded-full" />
              <span className="inline-flex items-center gap-1.5 text-[10px] sm:text-[11px] font-bold uppercase tracking-widest text-[#ff601e]">
                <svg
                  width="11"
                  height="11"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#ff601e"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                Featured
              </span>
            </div>
            <h2 className="font-bold text-[22px] sm:text-[26px] lg:text-[30px] text-[#1e4a46] leading-tight">
              Featured Products
            </h2>
            <p className="text-[12px] text-[#8faba9] mt-1 hidden sm:block">
              Handpicked medicines &amp; health essentials just for you
            </p>
          </div>

          <div className="flex items-center gap-4">
            <Link to="/featured-products">
              <button className="flex items-center gap-1.5 bg-[#162c2a] hover:bg-[#ff601e] text-white font-semibold text-[11px] sm:text-[12px] px-4 h-8 rounded-xl transition-all duration-200 shadow-[0_2px_8px_rgba(22,44,42,0.25)] hover:shadow-[0_4px_14px_rgba(255,96,30,0.4)] hover:-translate-y-0.5">
                View All
                <svg
                  width="11"
                  height="11"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </button>
            </Link>
          </div>
        </div>

        {/* ── Horizontal scroll carousel — 10 products, one row ── */}
        <div className="relative">
          {/* Left arrow */}
          <button
            onClick={() => {
              scrollRef.current?.scrollBy({ left: -220, behavior: "smooth" });
            }}
            className="absolute -left-3 sm:-left-5 top-1/2 -translate-y-1/2 z-20
              w-8 h-8 sm:w-10 sm:h-10 rounded-xl bg-white border-[1.5px] border-[#e2eaea]
              shadow-[0_2px_10px_rgba(22,44,42,0.1)] flex items-center justify-center
              text-[#374747] hover:bg-[#eaf4f3] hover:border-[#5fbdb3] hover:text-[#1e4a46]
              transition-all duration-200"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M19 12H5M12 5l-7 7 7 7" />
            </svg>
          </button>

          {/* Scrollable single row */}
          <div
            ref={scrollRef}
            className="flex gap-3 sm:gap-4 overflow-x-auto scrollbar-hide scroll-smooth py-2 px-1"
          >
            {displayedProducts.map((item, index) => {
              const isWishlisted = wishlistItems.some(
                (w) =>
                  w.product_id === item.product_id &&
                  w.variant_id === item.variant?.[0]?.variant_id,
              );
              const isOutOfStock = OutOfQuantityCheck(item.variant);
              const cartQty = getCartQuantity(item.variant[0]?.variant_id);
              const isMultiVariant = item?.variant?.length > 1;
              const originalPrice = item.variant[0]?.price;
              const discPrice = item.variant[0]?.discounted_price;

              const isOrange = index % 2 === 1;
              const accentGrad = isOrange
                ? "from-[#ff601e] to-[#e55519]"
                : "from-[#1e4a46] via-[#5fbdb3] to-[#1e4a46]";
              const borderHov = isOrange
                ? "hover:border-[#ff601e]/50"
                : "hover:border-[#5fbdb3]";
              const imgBg = isOrange ? "bg-[#fff8f5]" : "bg-[#f4fbfa]";
              const discCls = isOrange ? "text-[#ff601e]" : "text-[#5fbdb3]";
              const btnCls = isOrange
                ? "bg-[#ff601e] hover:bg-[#e55519] shadow-[0_2px_8px_rgba(255,96,30,0.3)] hover:shadow-[0_4px_14px_rgba(255,96,30,0.5)]"
                : "bg-[#1e4a46] hover:bg-[#ff601e] shadow-[0_2px_8px_rgba(22,44,42,0.2)] hover:shadow-[0_4px_14px_rgba(255,96,30,0.4)]";

              return (
                <div
                  key={index}
                  className={`group flex-shrink-0 w-[160px] sm:w-[185px] lg:w-[200px] xl:w-[210px]
                    bg-white border-[1.5px] border-[#e2eaea] ${borderHov} rounded-2xl overflow-hidden
                    shadow-[0_2px_14px_rgba(22,44,42,0.07)]
                    hover:shadow-[0_10px_36px_rgba(22,44,42,0.16)]
                    hover:-translate-y-2 transition-all duration-300 flex flex-col relative`}
                >
                  {/* Top accent */}
                  <div
                    className={`absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r ${accentGrad} opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10`}
                  />

                  {/* Discount badge */}
                  {item.discount_percent > 0 && (
                    <div className="absolute top-3 right-3 bg-[#ff601e] text-white text-[9px] sm:text-[10px] font-bold w-9 h-9 sm:w-10 sm:h-10 rounded-full flex flex-col items-center justify-center shadow-[0_2px_8px_rgba(255,96,30,0.45)] z-10 leading-tight text-center">
                      {item.discount_percent}%<br />
                      OFF
                    </div>
                  )}

                  {/* Wishlist */}
                  <button
                    className="absolute top-3 left-3 z-10 w-7 h-7 sm:w-8 sm:h-8 bg-white rounded-xl border border-[#e2eaea] flex items-center justify-center shadow-sm hover:border-[#5fbdb3] hover:bg-[#eaf4f3] transition-all duration-200"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!localStorage.getItem("authToken")) {
                        setShowLoginPopup(true);
                        return;
                      }
                      isWishlisted
                        ? removeFromWishlist(
                            item.product_id,
                            item.variant?.[0]?.variant_id,
                          )
                        : addToWishlist(item, item.variant?.[0]);
                    }}
                    disabled={wishlistLoading}
                    onMouseEnter={() => setTooltipOpen(index)}
                    onMouseLeave={() => setTooltipOpen(null)}
                  >
                    <img
                      src={isWishlisted ? wish : wishlist}
                      alt="wishlist"
                      className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                    />
                    {tooltipOpen === index && (
                      <div className="absolute left-9 top-0 bg-[#162c2a] text-white text-[10px] font-medium px-2 py-1 rounded-lg whitespace-nowrap shadow z-30">
                        {isWishlisted
                          ? "Remove from wishlist"
                          : "Add to wishlist"}
                      </div>
                    )}
                  </button>

                  {/* Image */}
                  <div
                    className={`w-full h-[160px] sm:h-[180px] lg:h-[200px] flex items-center justify-center ${imgBg} px-4 pt-6 pb-3 cursor-pointer`}
                    onClick={() => handleProductClick(item.product_id, item)}
                  >
                    <img
                      src={
                        item?.product_images?.image_url?.primary_image ||
                        "/default.svg"
                      }
                      alt={item.name}
                      className="max-h-full max-w-full object-contain group-hover:scale-110 transition-transform duration-300"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/default.svg";
                      }}
                    />
                  </div>

                  {/* Divider */}
                  <div className="w-full h-px bg-[#f1f5f5]" />

                  {/* Info */}
                  <div
                    className="px-3 pt-3 pb-2 flex-1 flex flex-col gap-1.5 cursor-pointer"
                    onClick={() => handleProductClick(item.product_id, item)}
                  >
                    <h3 className="font-semibold text-[12px] sm:text-[13px] text-[#1e4a46] line-clamp-2 leading-snug group-hover:text-[#ff601e] transition-colors duration-200">
                      {item.name}
                    </h3>
                    <div className="flex items-baseline gap-2">
                      {item.discount_percent > 0 && (
                        <span className="text-[11px] text-[#8faba9] line-through">
                          ₹{originalPrice}
                        </span>
                      )}
                      <span className="font-bold text-[14px] sm:text-[15px] text-[#1e4a46]">
                        ₹{discPrice}
                      </span>
                      {item.discount_percent > 0 && (
                        <span
                          className={`text-[10px] font-semibold ${discCls}`}
                        >
                          {item.discount_percent}% off
                        </span>
                      )}
                    </div>
                    {isOutOfStock && (
                      <span className="self-start text-[10px] font-semibold text-red-500 bg-red-50 border border-red-100 rounded-lg px-2 py-0.5">
                        Out of Stock
                      </span>
                    )}
                  </div>

                  {/* Cart */}
                  <div className="px-3 pb-3 pt-1">
                    {isMultiVariant ? (
                      <button
                        className={`w-full h-9 ${btnCls} disabled:bg-[#c5d5d4] disabled:cursor-not-allowed text-white text-[11px] sm:text-[12px] font-semibold rounded-xl flex items-center justify-center gap-1.5 transition-all duration-200`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (!localStorage.getItem("authToken")) {
                            setShowLoginPopup(true);
                            return;
                          }
                          handleProductClick(item.product_id, item);
                        }}
                      >
                        <img
                          src={addToCartIcon}
                          alt="Cart"
                          className="w-3.5 h-3.5 object-contain"
                        />
                        Choose Variant
                      </button>
                    ) : cartQty > 0 ? (
                      <div className="flex items-center justify-between bg-[#eaf4f3] border border-[#d4ecea] rounded-xl h-9 px-2">
                        <button
                          onClick={(e) =>
                            handleDecrease(e, item.variant[0], item)
                          }
                          className="w-7 h-7 flex items-center justify-center text-[#1e4a46] font-bold text-xl hover:bg-white rounded-lg transition-colors"
                        >
                          −
                        </button>
                        <span className="font-bold text-[14px] text-[#1e4a46] min-w-[24px] text-center">
                          {cartQty}
                        </span>
                        <button
                          onClick={(e) =>
                            handleIncrease(e, item.variant[0], item)
                          }
                          className="w-7 h-7 flex items-center justify-center text-[#1e4a46] font-bold text-xl hover:bg-white rounded-lg transition-colors"
                        >
                          +
                        </button>
                      </div>
                    ) : (
                      <button
                        className={`w-full h-9 ${btnCls} disabled:bg-[#c5d5d4] disabled:cursor-not-allowed text-white text-[11px] sm:text-[12px] font-semibold rounded-xl flex items-center justify-center gap-1.5 transition-all duration-200`}
                        onClick={async (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (!localStorage.getItem("authToken")) {
                            setShowLoginPopup(true);
                            return;
                          }
                          await handleAddToCart(item, item.variant[0], 1);
                        }}
                        disabled={isOutOfStock}
                      >
                        <img
                          src={addToCartIcon}
                          alt="Cart"
                          className="w-3.5 h-3.5 object-contain"
                        />
                        {isOutOfStock ? "Out of Stock" : "Add to Cart"}
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Right arrow */}
          <button
            onClick={() => {
              scrollRef.current?.scrollBy({ left: 220, behavior: "smooth" });
            }}
            className="absolute -right-3 sm:-right-5 top-1/2 -translate-y-1/2 z-20
              w-8 h-8 sm:w-10 sm:h-10 rounded-xl bg-white border-[1.5px] border-[#e2eaea]
              shadow-[0_2px_10px_rgba(22,44,42,0.1)] flex items-center justify-center
              text-[#374747] hover:bg-[#eaf4f3] hover:border-[#5fbdb3] hover:text-[#1e4a46]
              transition-all duration-200"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>

      {showLoginPopup && <Popup onClose={() => setShowLoginPopup(false)} />}
    </section>
  );
};

export default FeaturedProduct_home;
